/* RAUTER — product page: size choice, price, made-to-order notice */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-produto]');
  if (!raiz) return;

  var dadosEl = document.querySelector('[data-variantes-json]');
  if (!dadosEl) return;

  var variantes = [];
  try { variantes = JSON.parse(dadosEl.textContent); } catch (e) { return; }
  if (!variantes.length) return;

  var campoId = raiz.querySelector('[data-variante-id]');
  var preco = raiz.querySelector('[data-preco]');
  var aviso = raiz.querySelector('[data-aviso-encomenda]');
  var botao = raiz.querySelector('[data-comprar]');
  var botaoTexto = raiz.querySelector('[data-comprar-texto]');
  var radios = raiz.querySelectorAll('input[name="id"][type="radio"]');

  function textoSeguro(el, valor) {
    if (el) el.textContent = valor;
  }

  function aplicar(id) {
    var v = null;
    for (var i = 0; i < variantes.length; i++) {
      if (String(variantes[i].id) === String(id)) { v = variantes[i]; break; }
    }
    if (!v) return;

    if (campoId) campoId.value = v.id;

    if (preco) {
      preco.textContent = '';
      if (v.preco_comparado) {
        var riscado = document.createElement('s');
        riscado.textContent = v.preco_comparado;
        preco.appendChild(riscado);
      }
      var atual = document.createElement('span');
      atual.textContent = v.preco;
      preco.appendChild(atual);
    }

    if (aviso) aviso.classList.toggle('is-visible', !!(v.encomenda && v.disponivel));

    if (botao) {
      if (v.disponivel) {
        botao.removeAttribute('disabled');
        textoSeguro(botaoTexto, v.encomenda ? 'Order now — ships within 20 days' : 'Add to bag');
      } else {
        botao.setAttribute('disabled', '');
        textoSeguro(botaoTexto, 'Sold out');
      }
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* silencioso */ }
  }

  Array.prototype.forEach.call(radios, function (radio) {
    radio.addEventListener('change', function () { aplicar(radio.value); });
  });

  var marcado = raiz.querySelector('input[name="id"][type="radio"]:checked');
  if (marcado) {
    aplicar(marcado.value);
  } else if (campoId) {
    aplicar(campoId.value);
  }
})();